var isPage = "";
var Animate = {
	top: 0,
	show: 0
}
var animates = [];
var gaBlock = {
	top: 0
}
var gablocks = [];
var common = {
	init: ()=>{
		var resizeFlag;
		var resizeTimer = null;

		var $body = $("body");
		common.nav();
		common.resize();
		var imgArry = [];
		$("img").each(function(i){
			let src = $(this).attr("src");
			imgArry.push(src);
		});
		
		preload.startLoad(imgArry.length,imgArry, 1).done(function(){
			if(isPage === "top"){
				wheel.init();
				indicator.init();
				common.resize();
				video.init();
			}else if(isPage === "lip"){
				vol1.init();
				common.resize();
			}else if(isPage === "essence"){
				vol2.init();
				common.resize();
			}else if(isPage === "foundation"){
				vol3.init();
				common.resize();
			}else if(isPage === "cream"){
				vol4.init();
				common.resize();
			}else if(isPage === "basic"){
				vol5.init();
				common.resize();
			}
		});
		
		/* window resize
		----------------------------- */
		var resizeCallback = function() {
			common.resize();
			if(isPage === "essence"){
				vol2.resize();
			}else if(isPage === "cream"){
				vol4.resize();
			}
			resizeTimer = null;
		};
		
		$(window).off("resize").on("resize",function(){
			if(!$body.hasClass("resize")){
				$body.addClass("resize");
			}
			if(resizeTimer) {
				clearTimeout(resizeTimer);
			}
			resizeTimer = setTimeout(resizeCallback, 300);
		});
	},
	nav: ()=>{
		let $body = $("body");
		//glbnav
		var stop = 0;
		$("#btn-menu").off().on("click", function(){
			if(!$html.classList.contains("show-nav")){
				wheel.canScroll = false;
				$html.classList.add("nav");
				setTimeout(function(){
					$html.classList.add("show-nav");
				},200);
			}else{
				$html.classList.remove("show-nav");
				setTimeout(function(){
					wheel.canScroll = true;
					$html.classList.remove("nav");
				},600);
			}
		});
		//share
		var $this;
		$(".page-share li a").off().on("click", function(){
			$this = $(this);
			var idx = $(".page-share li a").index(this);
			shareTxt(idx);
		});
		$(".share li a").off().on("click", function(){
			$this = $(this);
			var idx = $(".share li a").index(this);
			shareTxt(idx);
		});
		function shareTxt(num){
			var url 	= $this.attr("data-url");

			if(num === 0){
				//Facebook
				window.open(
					'http://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url),
					'facebooksharedialog',
					'width=626,height=436');
				
			}else if(num === 1){
				//Twitter
				var txt = $this.attr("data-text");
				window.open(
					'http://twitter.com/share?url=' + encodeURIComponent(url) + "&amp;text=" + encodeURIComponent(txt),
					'twittersharedialog',
					'width=626,height=436');
			}else{
				//LINE
				var txt = $this.attr("data-text") + "\n" + url;
				window.open(
					'http://line.me/R/msg/text/?' + encodeURIComponent(txt),
					'linesharedialog',
					'width=626,height=436');
			}
		}
		if(isPage != "top"){
			//ストーリーによって、activeを分ける
			var storyNum = parseInt($("body").attr("data-num"));
			var num = 0;
			if(storyNum === 1){
				num = 2;
			}else{
				num = 1;
			}
			var cls = "active" + num;
			$("#othercontent").removeClass();
			$("#othercontent").addClass(cls);
			//other contents
			$("#othercontent .col_l_nav li a").off().on("click", function(){
				var idx = $("#othercontent .col_l_nav li a").index(this) + 1;
				var cls = "active" + idx;
				$("#othercontent").removeClass();
				$("#othercontent").addClass(cls);
			});
		}
	},
	resize: ()=>{
		var winW = window.innerWidth;
		var winH = window.innerHeight;
		var $body = $("body");

		if (window.matchMedia('all and (min-width : 864px)').matches) {
			isSmallScreen = false;
		} else if(window.matchMedia('all and (min-width : 0px)').matches) {
			isSmallScreen = true;
		}

		if(isPage === "top"){
			indicator.resize();
			wheel.resize();
			video.resize();
			if(isSmallScreen){
				let _w = window.innerWidth - $(".prologue-text").offset().left;
				$("#sp_cover").css({
					"width": _w + "px",
					"margin-left" : $(".prologue-text").offset().left + "px"
				});
				$("#main_sp_cover").css({
					"width": window.innerWidth + "px"
				});
			}else{
				$("#sp_cover").css({
					"width": "",
					"margin-left" : ""
				});
				$("#main_sp_cover").css({
					"width": ""
				});
			}
		}else if(isPage === "lip"){
			vol1.resize();
		}else if(isPage === "essence"){
			vol2.resize();
		}else if(isPage === "foundation"){
			vol3.resize();
		}
		common.checkBlock();
		setTimeout(function(){
			if($body.hasClass("resize")){
				$body.removeClass("resize");
				common.checkBlock();
			}
		},300);
	},
	checkBlock: function(){
		animates = [];
		$(".a").each(function(){
			var _a  = object(Animate);
			_a.top 	= Math.floor($(this).offset().top);
			_a.show = Math.floor(_a.top + $(window).height()/3);
			animates.push(_a);
		});


		//Google Analyticsのため
		gablocks = [];
		$(".gablock").each(function(i){
			var _g = object(gaBlock);
			_g.top = $(this).offset().top;
			gablocks.push(_g);
		})
	},
	scrollToPosition: (posY, duration) =>{
		var $page 	= $("html,body"),
			ease 	= "easeInOutCubic",
			flag 	= true;
		$page.animate({
			scrollTop : posY + "px"
		},{
			"duration" 	: duration,
			"easing" 	: ease,
			"complete"	: function(){
				if(flag){
					flag = false;
				}
			}
		});
	},
	scrl: () =>{
		var topD = $(document).scrollTop(),
			btmD = topD + $(window).height();

	},
	sendScrollPageGa: function(pageURL){
		let label = pageURL;
		var arry = location.href.split("/");
		//console.log(arry, arry.length);
		
		if(!label){
		}else{
			if(location.host.indexOf(":5757") >= 0 ){
				if(arry.length === 5){
					//top
					label = "/s/740149#" + label;
				}else if(arry.length === 6){
					if(arry[4] === "lip"){
						label = "/s/740158#" + label;
					}else if(arry[4] === "essence"){
						label = "/s/740161#" + label;
					}else if(arry[4] === "foundation"){
						label = "/s/740167#" + label;
					}
				}
			}else{
				label = location.pathname + "#" + label;
			}
			console.log(label);
			ga('send', 'pageview', label);
		}
		
	},
	sendClickGa: function(label, category, action){
		var style = "background-color: #000; color: #fff";
		console.log('label: ', label, '/ category: ', category,' / action: ', action);
		//ga('send', 'event', "ec:" + category, "ea:" + action, "el:" + label, 1);
		//ga('send', 'event', category, action, label, 1);
		console.log('------------------------------------')
	},
	checkVideoTimeupdate: function(id, target, cat){
		let $video = $("#" + id).find(".movie");
		let player = target;
		player.on('timeupdate', function(e) {
			if(!$video.hasClass("playing")){
				$video.addClass("playing");
			}
			let ratio = player.currentTime() / player.duration(), label, cls;
			let progress = ratio*100;
			$video.find(".ui-video .timeline p").css("width", progress + "%");
			
			if(ratio >= .97){
				label = '100percent_play';
				cls = "time100";
				if($video.hasClass("playing")){
					$video.removeClass("playing");
				}
			}else if(ratio >= 0.75 && ratio < 1){
				label = '75percent_play';
				cls = "time75";
			}else if(ratio >= 0.5 && ratio < 0.75){
				label = '50percent_play';
				cls = "time50";
			}else if(ratio >= 0.25 && ratio < 0.5){
				label = '25percent_play';
				cls = "time25"
			}else{
				label = "start_play";
				cls = "time0";
			}
			if(!$video.hasClass(cls)){
				$video.removeClass(function(index, className) {
					return (className.match(/\btime\S+/g) || []).join(' ');
				});
				$video.addClass(cls);
				let category 	= cat;
				let action 		= "play";
				//common.sendClickGa(label, category, action);
				//GAにプッシュする
			}
		});
	},
	checkMotionTimeupDate: function(id, target, cat){
		let player 	= target;
		let $movie 	= $("#" + id);
		let label 	= "",
			cls 	= "";
		//
		player.on('timeupdate', function(e) {
			if(!$movie.hasClass("vjs-playing")){ return false}

			var ratio = player.currentTime() / player.duration();
			//console.log(ratio)
			//console.log(id, ratio, player.currentTime, player.duration)
			//console.log(player.currentTime(),  player.duration()-.1)
			if(player.currentTime() >= player.duration()-.1){
				player.currentTime(0);
			}

			if(ratio >= .98){
				label 	= 'end';
				cls 		= "time100";
				sendMovie4Ga();
				
				//common.sendClickGa(label02, category, action);
			}else if(ratio >= 0 && ratio < 0.1){
				label 	= 'start';
				cls 		= "time0";
				sendMovie4Ga();
			}
			function sendMovie4Ga(){
				if(!$movie.hasClass(cls)){
					$movie.removeClass(function(index, className) {
						return (className.match(/\btime\S+/g) || []).join(' ');
					});
					$movie.addClass(cls);
					//console.log(cls)
					let category 	= cat;
					let action 		= "play";
					console.log(label, category, action);
					//common.sendClickGa(label, category, action);
					//GAにプッシュする
				}
			}
		});
	},
	checkScrolledPos: function(topD){
		var docH = $(document).height() - $(window).height();
		var per = Math.floor(topD/docH*100);
		var currentPer = 0;
		var currentPage = "story" + $("body").attr("data-num");
		var $body = $("body");
		
		if(per >= 0 && per < 25){
			var cls 	= "p0";
			currentPer 	= "scroll_start";
		}else if(per >= 25 && per < 50){
			var cls 	= "p25";
			currentPer 	= "25";
		}else if(per >= 50 && per < 75){
			var cls 	= "p50";
			currentPer 	= "50";
		}else if(per >= 75 && per < 100){
			var cls 	= "p75";
			currentPer 	= "75";
		}else if(per === 100){
			var cls = "p100";
			currentPer = "100";
		}
		if(!$body.hasClass(cls)){
			/*$body.removeClass(function(index, className) {
				return (className.match(/\bper\S+/g) || []).join(' ');
			});
			*/
			$body.addClass(cls);
			console.log("scroll:", currentPage, currentPer);
			
			__pParams.push({
				client_id: '162', c_1: 'cledepeau-beaute', c_2: 'WWD', c_3: 'scroll', c_4: currentPage, c_5: currentPer
			});
			$.getScript('//cdn.d2-apps.net/js/tr.js');
		}
	}
}
document.addEventListener('DOMContentLoaded', function () {
	isPage = $("body").attr("id");
	common.init();
});